module.exports = __webpack_public_path__ + "img/load-more-grey.125a5ed6.svg";